export default {"src":"/_next/static/media/Cremonese.d8d696fc.svg","height":401,"width":400,"blurWidth":0,"blurHeight":0};